export default "__VITE_ASSET__BRJRwiCp__"